export const COMPANY_CONFIG_RULES = {
  /** Tamaño máximo del archivo que el usuario puede seleccionar (MB). Se comprime antes de subir. */
  maxImageSize: parseInt(
    process.env.REACT_APP_COMPANY_MAX_AVATAR_SIZE ||
    process.env.REACT_APP_DEFAULT_MAX_AVATAR_SIZE ||
    "50"
  ),
};